// acta_patch_lot3_5_machine_installation_v1
// acta_patch_lot3_4_purchase_orders_v1
// acta_patch_lot3_3_quote_lines_pdf_send_v1
// acta_patch_lot3_quote_from_prospect_v1
import { api } from "../lib/api";


// acta_patch_lot3_quotes_foundation_v1
export const list = ({
  status = "",
  prospectId = "",
  clientId = "",
  page = 1,
  limit = 50,
} = {}) =>
  api
    .get("/quotes", {
      params: {
        status,
        prospect_id: prospectId,
        client_id: clientId,
        page,
        limit,
      },
    })
    .then((response) => response.data);


export const summary = () =>
  api
    .get("/quotes/summary")
    .then((response) => response.data);


export const create = (payload) =>
  api
    .post("/quotes", payload)
    .then((response) => response.data);


export const createFromOpportunity = (opportunityId, payload = {}) =>
  api
    .post(
      `/prospect-opportunities/${encodeURIComponent(opportunityId)}/quote`,
      payload
    )
    .then((response) => response.data);


// ACTA_QUOTE_REJECTED_EDIT_API_V1
export const update = (quoteId, payload) =>
  api
    .put(`/quotes/${quoteId}`, payload)
    .then((r) => r.data);

export const submit = (quoteId) =>
  api
    .post(`/quotes/${quoteId}/submit`)
    .then((response) => response.data);


export const approve = (quoteId) =>
  api
    .post(`/quotes/${quoteId}/approve`)
    .then((response) => response.data);


export const reject = (quoteId, reason) =>
  api
    .post(`/quotes/${quoteId}/reject`, {
      reason,
    })
    .then((response) => response.data);


export const createPurchaseOrder = (quoteId, payload = {}) =>
  api
    .post(`/quotes/${quoteId}/purchase-order`, payload)
    .then((response) => response.data);


// acta_patch_lot3_3_quote_lines_pdf_send_v1
export const downloadPdf = (quoteId, { preview = false } = {}) =>
  api
    .get(`/quotes/${quoteId}/pdf`, {
      params: { preview },
      responseType: "blob",
    })
    .then((response) => response.data);


export const exportEvoliz = (quoteId) =>
  api
    .get(`/quotes/${quoteId}/evoliz-export`, {
      responseType: "blob",
    })
    .then((response) => response.data);


export const send = (quoteId) =>
  api
    .post(`/quotes/${quoteId}/send`)
    .then((response) => response.data);


export const share = (quoteId, payload) =>
  api
    .post(`/quotes/${quoteId}/share`, payload)
    .then((response) => response.data);


export const accept = (quoteId) =>
  api
    .post(`/quotes/${quoteId}/accept`)
    .then((response) => response.data);


// ACTA_AFFAIRES_WORKFLOW_API_V18
export const decideFinancing = (
  quoteId,
  {
    decision,
    reason = "",
    provider = "",
    prepareGmao = false,
  }
) =>
  api
    .post(
      `/quotes/${quoteId}/financing-decision`,
      {
        decision,
        reason,
        financing_provider: provider || null,
        prepare_gmao: Boolean(prepareGmao),
      }
    )
    .then((response) => response.data);


export const finalizeSale = (
  quoteId,
  { prepareGmao = true } = {}
) =>
  api
    .post(
      `/quotes/${quoteId}/finalize-sale`,
      { prepare_gmao: Boolean(prepareGmao) }
    )
    .then((response) => response.data);


export const refuse = (quoteId, reason = "") =>
  api
    .post(`/quotes/${quoteId}/refuse`, {
      reason,
    })
    .then((response) => response.data);



// acta_patch_lot3_4_purchase_orders_v1
export const listPurchaseOrders = ({
  status = "",
  prospectId = "",
  clientId = "",
  page = 1,
  limit = 50,
} = {}) =>
  api
    .get("/purchase-orders", {
      params: {
        status,
        prospect_id: prospectId,
        client_id: clientId,
        page,
        limit,
      },
    })
    .then((response) => response.data);


export const downloadPurchaseOrderPdf = (orderId) =>
  api
    .get(`/purchase-orders/${orderId}/pdf`, {
      responseType: "blob",
    })
    .then((response) => response.data);


export const signPurchaseOrder = (orderId) =>
  api
    .post(`/purchase-orders/${orderId}/sign`)
    .then((response) => response.data);


export const payPurchaseOrder = (orderId) =>
  api
    .post(`/purchase-orders/${orderId}/pay`)
    .then((response) => response.data);



// acta_patch_lot3_5_machine_installation_v1
export const preparePurchaseOrderInstallation = (orderId, payload) =>
  api
    .post(
      `/purchase-orders/${orderId}/prepare-installation`,
      payload
    )
    .then((response) => response.data);
